import React, { useState, useEffect, Fragment } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { Row, Col, Table, Spinner } from "react-bootstrap";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import Edit from "./Edit";
import ErrorModal from "../../ErrorModal";
import GetAdvType from "./GetAdvType";
import DeleteConfirmation from "../../shared/DeleteConfirmation";

const baseURL = process.env.REACT_APP_API_JOBS;

const Listdelete = ({ increment, counter, setCounter, mekhraz_id }) => {
  const [pirsomeem, setPirsomeem] = useState(null);
  const [advType, setAdvType] = useState([]);
  const [pirsomId, setPirsomId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const [loading, setLoading] = useState(true);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "advtype/", {
          signal: controller.signal,
        });
        isMounted && setAdvType(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
  }, []);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "advertising?mekhraz_id=" + mekhraz_id,
          {
            signal: controller.signal,
          }
        );
        isMounted && setPirsomeem(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [counter]);
  const handleEditClick = (event, pirsom) => {
    event.preventDefault();
    setPirsomId(pirsom.id);
  };
  const handleCancelClick = () => {
    setPirsomId(null);
  };

  if (!pirsomeem) return null;
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div>
          <Row>
            <Col sm="10" md={{ size: 3, offset: 1 }}>
              <form onSubmit={increment}>
                <Table hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>תאריך פרסום</th>
                      <th>סוג מדיה</th>
                      <th>קישור</th>
                      <th>פעולות</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pirsomeem?.map((pirsom) => (
                      <Fragment key={pirsom.id}>
                        {pirsomId === pirsom.id ? (
                          <Edit
                            pirsom={pirsom}
                            handleCancelClick={handleCancelClick}
                            increment={increment}
                            counter={counter}
                            setPirsomId={setPirsomId}
                            advType={advType}
                          />
                        ) : (
                          <ReadOnlyRows
                            pirsom={pirsom}
                            handleEditClick={handleEditClick}
                            increment={increment}
                            setPirsomId={setPirsomId}
                            advType={advType}
                            setShowError={setShowError}
                            setErrorMessage={setErrorMessage}
                            setErrorHeader={setErrorHeader}
                          />
                        )}
                      </Fragment>
                    ))}
                  </tbody>
                </Table>
              </form>
            </Col>
          </Row>
        </div>
        <ErrorModal
          showError={showError}
          setShowError={setShowError}
          errorMessage={errorMessage}
          errorHeader={errorHeader}
        />
      </>
    );
  }
};
export default Listdelete;

const ReadOnlyRows = ({
  pirsom,
  handleEditClick,
  setPirsomId,
  increment,
  advType,
  setShowError,
  setErrorMessage,
  setErrorHeader,
}) => {
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [deleteObj, setDeleteObj] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const showDeleteModal = (type, id, event) => {
    setType(type);
    setId(id);
    setDeleteObj(event);
    setDeleteMessage(`מחיקת פירסום "${pirsom.id}": האם אתה בטוח? `);
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    async function deletePost() {
      let isMounted = true;
      const controller = new AbortController();
      const getData = async () => {
        try {
          const response = await axiosPrivate.delete(
            baseURL + "advertising/" + pirsom.id,
            {
              signal: controller.signal,
            }
          );
          isMounted && increment();
          alert("נמחקה בהצלחה");
        } catch (err) {
          if (err.response) {
            alert(HandleHttpErrors(err.response.status));
            if (err.response.status === 401) {
              navigate("/login", { state: { from: location }, replace: true });
            } else if (err.response.status === 403) {
              alert(HandleHttpErrors(err.response.status));
            }
            console.log(err.response);
          } else if (err.request) {
            alert(
              " The client never received a response, and the request was never left"
            );
            console.log(err.request);
          } else {
            console.log(err);
            alert(" Anything else");
          }
        }
      };
      getData();
    }
    deletePost();
    setPirsomId(null);
  };

  return (
    <>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={pirsom.id}
        event={deleteObj}
        message={deleteMessage}
      />
      <tr>
        <td>{pirsom.id}</td>
        <td>{pirsom.adv_date}</td>
        <td>
          <GetAdvType advType={advType} typeIndex={pirsom.adv_type} />
        </td>
        <td>
          <a href={pirsom.link} target="blank" className="myHref">
            {pirsom.link}
          </a>
        </td>
        <td>
          <button
            type="button"
            className="btn btn-success"
            onClick={(event) => handleEditClick(event, pirsom)}
          >
            <FiEdit2 />
          </button>
          <span> </span>
          <button
            type="button"
            className="btn btn-danger"
            onClick={(event) => showDeleteModal("pirsom", pirsom.id, event)}
          >
            <FiTrash2 />
          </button>
        </td>
      </tr>
    </>
  );
};
